import { useLearningUiTranslation } from '@features/learning/shared/use-learning-ui-translation'
import { useState } from 'react'
import type { FlashcardGameTemplateProps } from '../template-types'
import { playLearningFeedbackAudio } from '@features/learning/shared/learning-feedback-audio'
import {
  LearningTemplateContinueActions,
  LearningTemplateExerciseFrame,
  LearningTemplatePromptMedia,
  LearningQuizTemplate,
} from '@features/learning/shared/templates'
import '../flashcard-game.css'

export function Template1({
  onContinue,
  prompt,
}: FlashcardGameTemplateProps) {
  const ui = useLearningUiTranslation()
  const [selectedAnswerId, setSelectedAnswerId] = useState<string | null>(null)
  const options = prompt.options ?? []
  const selectedAnswerIndex =
    selectedAnswerId === null ? null : options.findIndex((option) => option.id === selectedAnswerId)
  const selectedOption =
    selectedAnswerId === null
      ? null
      : options.find((option) => option.id === selectedAnswerId) ?? null
  const selectedResult = selectedOption
    ? selectedOption.isCorrect
      ? 'correct'
      : 'incorrect'
    : null

  return (
    <LearningTemplateExerciseFrame
      className="flashcardGameTemplate"
      media={
        <LearningTemplatePromptMedia
          audio={prompt.audio}
          audioAutoPlayKey={prompt.id}
          audioAutoPlayOnLoad
          audioVariant="flashcard"
          className="flashcardGamePromptMedia"
          image={prompt.image}
          imageAlt={ui("Flashcard prompt")}
          showAdvancedAudioControls
        />
      }
      questionText={prompt.question}
      sourceOwner="flashcards"
    >
      <LearningQuizTemplate
        answers={options.map((option) => ({
          audio: option.audio ?? undefined,
          id: option.id,
          image: option.image,
          isCorrect: option.isCorrect,
          label: option.label ?? null,
        }))}
        itemId={prompt.id}
        onAnswer={(answerIndex) => {
          const option = options[answerIndex]

          if (selectedAnswerId !== null || !option) {
            return
          }

          setSelectedAnswerId(option.id)
          playLearningFeedbackAudio(option.isCorrect ? 'correct' : 'incorrect')
        }}
        result={selectedResult}
        selectedAnswerId={selectedAnswerId}
        selectedAnswerIndex={selectedAnswerIndex}
        sourceOwner="flashcards"
      />

      {selectedResult ? (
        <LearningTemplateContinueActions
          incorrectReviewText={prompt.answerText ?? null}
          incorrectReviewTranslationText={prompt.answerTranslation ?? null}
          onContinue={onContinue}
          result={selectedResult}
        />
      ) : null}
    </LearningTemplateExerciseFrame>
  )
}
